/* jellopencil.com — shared lightbox
   Works on any element matching the selectors below, as long as it contains
   an <img> plus a child element with class "t" (title) and optionally "m"
   (year/size meta). Used by the hero, the homepage gallery, and the full
   Works grid. Safe to include on every page: if none of these elements
   exist on a given page, this script simply does nothing. */
document.addEventListener('DOMContentLoaded', function () {
  const lightbox = document.getElementById('lightbox');
  if (!lightbox) return;

  const lightboxImg = document.getElementById('lightbox-img');
  const lightboxTitle = document.getElementById('lightbox-title');
  const lightboxMeta = document.getElementById('lightbox-meta');

  function openLightbox(src, title, meta) {
    lightboxImg.src = src;
    lightboxImg.alt = title;
    lightboxTitle.textContent = title;
    lightboxMeta.textContent = meta || '';
    lightbox.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lightbox.classList.remove('active');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('.piece, .pf-piece, .hero-frame').forEach((el) => {
    const img = el.querySelector('img');
    if (!img) return;
    el.classList.add('lightbox-trigger');
    el.addEventListener('click', () => {
      const titleEl = el.querySelector('.t');
      const metaEl = el.querySelector('.m');
      // Prefer a full-resolution image (data-full) if provided, else the img's own src.
      const fullSrc = el.getAttribute('data-full') || img.currentSrc || img.src;
      openLightbox(fullSrc, titleEl ? titleEl.textContent : img.alt, metaEl ? metaEl.textContent : '');
    });
  });

  lightbox.addEventListener('click', (e) => { if (e.target === lightbox) closeLightbox(); });
  const closeBtn = lightbox.querySelector('.lightbox-close');
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeLightbox(); });

  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // Mobile hamburger menu
  const menuToggle = document.getElementById('menu-toggle');
  const navLinks = document.getElementById('nav-links');
  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
    navLinks.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('open');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }
});
